import * as React from 'react';
import ConfirmBeforeActionDialog from './dialog-confirm-before-action';

export default function ConfirmBeforeDeleteDialog(props) {

  return (
    <ConfirmBeforeActionDialog {...props}  title="Confirm Delete" confirmMessage={props.confirmMessage || "Please confirm you want to delete this record"} proceedButtonLabel="Delete" cancelButtonLabel="Cancel"/>
  );
}